export const MULTIPLY_VAULT_PILL_CHANGE_SUBJECT = 'MultiplyPillChange'
